import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { getPhoneText } from '../../../components/demand/utils';
import { isFakeEmail } from '../../../utils/validate';
import { EUserType } from '../../../constants/requestDemand';
import { TRequestValues } from '../../../types/requestDemand';
import { changeUserType, submitDemandRequest } from '../../../actions/requestDemand';
import { RequestDemandForm } from '../../../components/RequestDemand/components/RequestDemandForm';
import { formatPhoneNumber } from '../../../components/RequestDemand/utils';
import { selectUser } from '../../../selectors/offerData/offer';
import { selectLastDemandRequest } from '../../../selectors/requestDemand';
import { trackChangedUserType, trackSendFormClick } from '../../../components/demand/utils/tracking';

export const mapStateToProps = (state: IState): TRequestValues => {
  const lastDemandRequest = selectLastDemandRequest(state);
  const user = selectUser(state);
  const userEmail = user && user.isAuthenticated && user.email && !isFakeEmail(user.email) ? user.email : '';
  const phone = lastDemandRequest?.phone || getPhoneText(user);
  const email = lastDemandRequest?.email || userEmail;
  const userType = lastDemandRequest?.isHomeowner ? EUserType.HOME_OWNER : EUserType.USER;

  return {
    phone: phone ? formatPhoneNumber(phone) : '',
    email,
    userType,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<IState>) => ({
  onSubmit(data: TRequestValues) {
    dispatch(submitDemandRequest(data));
    trackSendFormClick(data.userType);
  },
  onChangeUserType(userType: EUserType) {
    dispatch(changeUserType(userType));
    trackChangedUserType(userType);
  },
});

export const RequestDemandFormContainer = connect(mapStateToProps, mapDispatchToProps)(RequestDemandForm);
